module.exports = "../static/media/right.2aea13e8.png";